import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const CustomSelect = ({
    label = "Select",
    value = "",
    onChange,
    options = [],
    fullWidth = true,
    size = "small",
    minWidth = 120,
    disabled = false
}) => {
    return (
        <Box sx={{ minWidth: minWidth }}>
            <FormControl fullWidth={fullWidth} size={size} disabled={disabled}>
                <InputLabel>{label}</InputLabel>

                <Select
                    value={value}
                    label={label}
                    onChange={(e) => onChange(e.target.value)}
                >
                    {options.map((opt, index) => (
                        <MenuItem key={index} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

export default CustomSelect;